import { Entity } from 'src/models/entity/entity';
import { IAuthService } from '../../auth/auth-service';
import { ILogService } from '../../common/log/log-service';
import { IEntityService } from './entity-service';
import { AppEnvironment } from 'src/models/common/environment/environment';

export class EntityServiceImpl implements IEntityService {
  private apiPath = 'entity/keycloakbyId/agenda';

  constructor(
    private logService: ILogService,
    private authService: IAuthService,
    private localEnvironment: AppEnvironment,
  ) {}

  async list(): Promise<Entity[]> {
    try {
      await this.logService.info('EntityServiceImpl.list -> start');

      const result = await this.authService.httpCentral.get(this.apiPath);

      return result ?? [];
    } catch (error) {
      console.error('EntityServiceImpl.list -> error', error);
      return [];
    } finally {
      await this.logService.info('EntityServiceImpl.list -> end');
    }
  }
}
